import Moment from 'moment'

const MomentDate = (props) => {
    if(props === undefined || props.value === undefined || props.value === null)
        return (props !== undefined && props !== null && props.fallbackValue !== undefined) ? props.fallbackValue : null;

    if (props.format !== undefined && props.format !== null)
        return Moment(props.value).format(props.format);

    let datePart = Moment(props.value).format('l');
    return datePart === 'Invalid date' ? datePart : (datePart + (props.withTime ? ` ${Moment(props.value).format('LTS')}` : ''));
}

export { MomentDate };